import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { LEARNING_PATHS_SECTION_ID } from 'constants/marketingAnchors';
import { ROUTES } from 'constants/routes';

export function useMarketingAuthNav() {
  const navigate = useNavigate();

  const goToLogin = (redirectTo?: string) => {
    navigate(ROUTES.LOGIN, {
      state: redirectTo ? { from: { pathname: redirectTo } } : undefined,
    });
  };

  const requireAuth = (redirectTo: string) => goToLogin(redirectTo);

  const scrollToAnchor = useCallback((id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const scrollToLearningPaths = () => {
    scrollToAnchor(LEARNING_PATHS_SECTION_ID);
  };

  return { goToLogin, requireAuth, scrollToAnchor, scrollToLearningPaths };
}
